export const heading = 'Navigate the unexpected.';
export const body =
  'Changes like market volatility, inflation and personal circumstances are inevitable. As these arise, your advisor is available by phone, text message, video, or email to help you confidently adjust. ';
